import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import AddFiles from "components/EboStoreV4/CommonComponents/AddFiles/AddFiles";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdateRenovationFieldsData,
	autoUpdatestoreMainFieldsData,
	billerDetailsTableColumns,
	getColDefaultValue,
	leaseDetails,
	renovationFileColumns,
	storeBasicDetailsFields,
	storeCamTableColumns,
	storeMainFields,
	storeRenovationTableColumns,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { constraintsOptions } from "data/globalData";
import { inputTypes, statusOptions } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useEffect, useState } from "react";

const AddOrEditModal = ({
	modal,
	setModal,
	type,
	defaultData,
	createDetailsApi,
	selectedStore,
	setSelectedStore,
	handleUpdateDetails,
	handleFileUploadDetails,
	handleGetStoreFiles,
}) => {
	const defFields = (() => {
		let obj = {};
		storeRenovationTableColumns?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [renovationDetails, setRenovationDetails] = useState(type === addOrEditModelAction.UPDATE ? defaultData : defFields);

	const handleModalclose = () => {
		setModal(false);
	};
	const [allFiles, setAllFiles] = useState([]);

	const handleCallback = (data) => {
		setAllFiles(data);
	};
	console.log("Renovation", defaultData);
	useEffect(() => {
		defaultData !== undefined &&
			handleGetStoreFiles(storesLinkedTables.store_renovation_details.key, defaultData?.id, handleCallback);
	}, []);

	const handleBillerCallbackFun = (data) => {
		if (type === addOrEditModelAction.UPDATE) {
			let filtredData = selectedStore?.eboStoreBillerDetails.filter((data) => data.id !== renovationDetails.id);
			let billerDetail = [...filtredData, renovationDetails];
			setSelectedStore({ ...selectedStore, eboStoreBillerDetails: billerDetail });
		} else {
			let billerDetail = [...selectedStore?.eboStoreBillerDetails, data];
			setSelectedStore({ ...selectedStore, eboStoreBillerDetails: billerDetail });
		}
		setRenovationDetails(defFields);
		setModal(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		console.log("ALFILES RENO", allFiles);
		const filtredFiles = allFiles.filter((data) => data?.isNew);
		//this if for file upload
		let updatedData = await handleFileUploadDetails(
			filtredFiles,
			selectedStore.store_code,
			storesLinkedTables.store_renovation_details.key
		);
		let updatedBiller = { ...renovationDetails, ebo_store_v4_id: selectedStore.store_code, files: updatedData };
		console.log("updatedBiller", updatedBiller, updatedData);
		if (type === addOrEditModelAction.UPDATE) {
			await handleUpdateDetails(storesLinkedTables.store_renovation_details.seqMethod, updatedBiller, handleBillerCallbackFun);
		} else {
			createDetailsApi(storesLinkedTables.store_renovation_details.seqMethod, updatedBiller, handleBillerCallbackFun);
		}
	};

	const handleAddFile = (data) => {
		setAllFiles([...allFiles, data]);
	};
	const formStack = {
		width: { xs: "80%", sm: "40%", md: "25%" },
	};
	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Renovation Details</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{storeRenovationTableColumns?.map((row) => {
							return (
								<RenderInputField
									column={row}
									data={renovationDetails}
									setData={setRenovationDetails}
									width="24%"
									selectOptObjName={"option_data"}
								/>
							);
						})}
						<AddFiles
							columns={renovationFileColumns}
							tableName={storesLinkedTables.store_renovation_details.key}
							rowId={defaultData?.id}
							handleAddFile={handleAddFile}
							files={allFiles}
							selectedStore={selectedStore}
						/>
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button
						variant="contained"
						disabled={selectedStore.status === statusOptions.PUBLISHED.key}
						sx={{ justifySelf: "center" }}
						type="submit">
						{type === addOrEditModelAction.UPDATE ? "UPDATE" : "CREATE"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
